import i18n from '@/lang/i18n'

export default [{
  path: '/admin/apply/staff/list',
  name: 'staffList',
  component: () => import('@/views/apply/staff/list/index'),
  meta: {
    title: i18n.t('router.staff.staff_manage'),
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/staff/role/list',
  name: 'staffRoleList',
  component: () => import('@/views/apply/staff/role/list/index'),
  meta: {
    title: i18n.t('router.staff.role_manage'),
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/staff.js